export default __webpack_public_path__ + "static/media/X33_CR7_Popout_V1-id.84dc3354.png";